module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M12.144 0C5.438 0 0 5.438 0 12.144c0 8.58 8.726 17.158 11.384 19.574a1.165 1.165 0 0 0 1.52 0c2.658-2.416 11.384-10.994 11.384-19.574C24.29 5.438 18.852 0 12.144 0zm0 18c-3.312 0-6-2.688-6-6s2.688-6 6-6 6 2.688 6 6-2.686 6-6 6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/location-pin-1.js
// module id = 1238
// module chunks = 14